import classNames from 'classnames';
import { useCallback } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { AssetStatusList } from '~/components/Asset/Status/List/AssetStatusList';
import { useChallengeExpect } from '~/components/Challenge/Challenge.hooks';
import { ChallengeGuideCta } from '~/components/Challenge/Cta/Guide/ChallengeGuideCta';
import { ChallengeScoreUpCta } from '~/components/Challenge/Cta/Score/ChallengeScoreUpCta';
import { ChallengeEventCard } from '~/components/Challenge/Event/Card/ChallengeEventCard';
import { ChallengeStatus } from '~/components/Challenge/Status/ChallengeStatus';
import { QueryErrorBoundary } from '~/components/Error';
import { SignUpCta } from '~/components/Home/SignUp/SignUpCta';
import { useMember } from '~/components/Member/Member.hooks';
import styles from './HomeChallenge.module.scss';

export type HomeChallengeProps = {
  className?: string;
};

export const HomeChallenge = ({ className }: HomeChallengeProps) => {
  const {
    data: { isLoggedIn },
  } = useMember();

  const {
    data: { myRank },
  } = useChallengeExpect();

  const history = useHistory();
  const onEventCardClick = useCallback(() => {
    history.push('/challenge/leaderboard');
  }, [history]);

  return (
    <div className={classNames(styles.root, className)} data-event-category="challenge_banner">
      <div className={styles.asideLeft}>
        {isLoggedIn ? (
          <QueryErrorBoundary>
            <ChallengeStatus />
          </QueryErrorBoundary>
        ) : (
          <QueryErrorBoundary>
            <ChallengeEventCard className={styles.eventCard} onClick={onEventCardClick} />
          </QueryErrorBoundary>
        )}
      </div>
      <div className={styles.asideRight}>
        {isLoggedIn ? (
          <QueryErrorBoundary
            FallbackComponent={() => (
              <Link
                to="/challenge/guide"
                className={styles.guide}
                data-event="click"
                data-event-target="challenge_banner_guide">
                <ChallengeGuideCta />
              </Link>
            )}>
            <AssetStatusList />
          </QueryErrorBoundary>
        ) : (
          <Link
            to="/challenge/guide"
            className={styles.guide}
            data-event="click"
            data-event-target="challenge_banner_guide">
            <ChallengeGuideCta />
          </Link>
        )}
      </div>
      <div className={styles.footer}>
        {!isLoggedIn && <SignUpCta />}
        {myRank && <ChallengeScoreUpCta />}
      </div>
    </div>
  );
};
